import { render, staticRenderFns } from "./WizardConfirmDialog.component.vue?vue&type=template&id=694313fc&"
import script from "./WizardConfirmDialog.component.vue?vue&type=script&lang=ts&"
export * from "./WizardConfirmDialog.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports